exports = function() {};

module.exports = exports;
